export enum Actions {
  ALL_SUBMISSIONS = 'all-submissions',
  EDITOR = 'editor',
  INTERMEDIATE_APPROVER = 'intermediate-approver',
  FINAL_APPROVER = 'final-approver',
}
